module.exports = __webpack_public_path__ + "static/media/360_slide3.6352ae52.png";